import type { RootState } from '@/store';
import type { ColunaDisponivel } from '../types';

export const selectColunasDisponiveis = (state: RootState): ColunaDisponivel[] =>
  state.negociacaoColunas.disponiveis.items;

export const selectColunasDisponiveisLoading = (state: RootState): boolean =>
  state.negociacaoColunas.disponiveis.loading;

export const selectColunasDisponiveisLoaded = (state: RootState): boolean =>
  state.negociacaoColunas.disponiveis.loaded;

export const selectColunasDisponiveisEscritorioId = (state: RootState): string | null =>
  state.negociacaoColunas.disponiveis.escritorioId;

export const selectColunasPreferenciaIds = (state: RootState): string[] =>
  state.negociacaoColunas.preferencia.fieldIds;

export const selectColunasPreferenciaLoaded = (state: RootState): boolean =>
  state.negociacaoColunas.preferencia.loaded;

export const selectColunasPreferenciaEscritorioId = (state: RootState): string | null =>
  state.negociacaoColunas.preferencia.escritorioId;

export const selectColunasPreferenciaSaving = (state: RootState): boolean =>
  state.negociacaoColunas.preferencia.saving;

export const selectColunasSelecionadasOrdenadas = (state: RootState): ColunaDisponivel[] => {
  const disponiveis = state.negociacaoColunas.disponiveis.items;
  const ids = state.negociacaoColunas.preferencia.fieldIds;
  const byId = new Map(disponiveis.map((c) => [c.fieldId, c]));
  return ids.map((id) => byId.get(id)).filter((c): c is ColunaDisponivel => Boolean(c));
};
